<div class="report-popup-container">

  <!-- Header -->
  <div class="popup-header">
    <h2>Retrieve Reports</h2>
    <mat-icon class="close-btn" (click)="closeModal()">close</mat-icon>
  </div>

  <div class="popup-body">

    <!-- Vessel Dropdown -->
    <div class="row align-items-center mb-3">
      <div class="col-md-4">
        <label>Vessel Name</label>
      </div>
      <div class="col-md-8">
        <select class="form-control" [(ngModel)]="selectedVesselIMO" (change)="onVesselChange()">
          <option value="" disabled selected>Select vessel</option>
          <option *ngFor="let v of vesselList" [value]="v.vesselIMO">
          {{ v.vesselName.toUpperCase() }} ({{ v.vesselIMO }})
          </option>
        </select>
      </div>
    </div>

    <!-- Date Dropdown (from API) -->
    <div class="row align-items-center mb-3">
      <div class="col-md-4">
        <label>Date</label>
      </div>
      <div class="col-md-8">
        <select class="form-control" [(ngModel)]="selectedDate" (change)="onDateChange()" [disabled]="!dateList.length">
          <option value="" disabled selected>
            {{ dateList.length ? 'Select date' : 'Select vessel first' }}
          </option>

          <option *ngFor="let d of dateList" [value]="d.value">
            {{ d.label }}
          </option>
        </select>

      </div>
    </div>


    <div class="row align-items-start mb-4">
      <div class="col-md-4">
        <label>Event</label>
      </div>

      <div class="col-md-8">
        <div *ngIf="!eventList.length" class="form-control event-placeholder">Select date first</div>

        <div *ngIf="eventList.length" class="event-list">
          <ng-container *ngFor="let e of eventList">
          <div class="event-row" [class.selected]="selectedEvent?.id === e.id"
            (click)="selectedEvent = e">
            <input type="radio" name="eventSelect" [checked]="selectedEvent?.id === e.id" />

            <div class="event-info">
              <span class="event-name">
                {{ e.eventsList }} — {{ e.report_timestamp | date:'dd MMM yyyy, HH:mm':'UTC' }} UTC
              </span>
              <span class="event-status">
                <span [class.ok]="e.submitted" [class.bad]="!e.submitted">
                  {{ e.submitted ? '✔ Submitted' : '✖ Not Submitted' }}
                </span>
                |
                <span [class.ok]="e.verified" [class.bad]="!e.verified">
                  {{ e.verified ? '✔ Verified' : '✖ Not Verified' }}
                </span>
                <ng-container *ngIf="e.force_submission">
                  |
                  <span class="force">⚡ Force Ingested</span>
                </ng-container>
              </span>
            </div>

            <div class="event-actions">
              <button type="button" class="event-icon-btn open-btn" matTooltip="Open" matTooltipPosition="above"
                aria-label="Open" [disabled]="actionInProgressId !== null"
                (click)="$event.stopPropagation(); openEvent(e)">
                <mat-icon>lock_open</mat-icon>
              </button>
              <button type="button" class="event-icon-btn overwrite-btn" matTooltip="Overwrite" matTooltipPosition="above"
                aria-label="Overwrite" [class.active]="overwriteTarget?.id === e.id" [disabled]="actionInProgressId !== null"
                (click)="$event.stopPropagation(); overwriteTarget?.id === e.id ? cancelOverwrite() : startOverwrite(e)">
                <mat-icon>upload_file</mat-icon>
              </button>
              <button type="button" class="event-icon-btn delete-btn" matTooltip="Delete" matTooltipPosition="above"
                aria-label="Delete" [disabled]="actionInProgressId !== null"
                (click)="$event.stopPropagation(); deleteEvent(e)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>

          <!-- OVERWRITE: upload the replacement JSON (any event / time) -->
          <div *ngIf="overwriteTarget?.id === e.id" class="overwrite-panel">
            <input #overwriteInput type="file" accept=".json,application/json" hidden
              (change)="onOverwriteFileSelected(overwriteInput)" />

            <div class="overwrite-file">
              <button type="button" class="btn overwrite-choose-btn" [disabled]="actionInProgressId !== null"
                (click)="overwriteInput.click()">
                <mat-icon>attach_file</mat-icon>
                {{ overwriteFile ? 'Change file' : 'Choose JSON file' }}
              </button>
              <span class="overwrite-file-name">{{ overwriteFile?.name || 'No file selected' }}</span>
            </div>

            <div *ngIf="overwritePreview" class="overwrite-preview">
              <span class="from">{{ e.eventsList }} — {{ e.report_timestamp | date:'dd MMM yyyy, HH:mm':'UTC' }} UTC</span>
              <mat-icon>arrow_forward</mat-icon>
              <span class="to">{{ overwritePreview.eventsList }} — {{ overwritePreview.time }} UTC</span>
            </div>
            <div *ngIf="overwriteError" class="overwrite-error">{{ overwriteError }}</div>

            <div class="overwrite-actions">
              <button type="button" class="btn overwrite-cancel-btn" [disabled]="actionInProgressId !== null"
                (click)="cancelOverwrite()">Cancel</button>
              <button type="button" class="btn overwrite-confirm-btn"
                [disabled]="!overwriteFile || actionInProgressId !== null" (click)="confirmOverwrite()">
                {{ actionInProgressId === e.id ? 'Overwriting...' : 'Overwrite' }}
              </button>
            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </div>


    <!-- Buttons -->
    <div class="text-center mt-3">
      <button class="btn submit-btn" (click)="fetchReport()"
        [disabled]="!selectedVesselIMO || !selectedDate || !selectedEvent || isSubmitting">
        {{ isSubmitting ? 'Checking...' : 'Retrieve' }}
      </button>


      <!-- <button class="btn cancel-btn" (click)="closeModal()">
        Cancel
      </button> -->
    </div>

  </div>
</div>